<template>
  <div class="login page">
    <loginComp title="Đăng nhập"></loginComp>
  </div>
</template>
<script>
import LoginComp from "@/components/LoginComp.vue";
export default {
  components: {
    loginComp: LoginComp,
  },
};
</script>
